const freelancerRates = [
    {"min": 0, "max": 3742000, "percentage": 0},
    {"min": 3742000, "max": 5589000, "percentage": 10},
    {"min": 5589000, "max": 9322000, "percentage": 15}, 
    {"min": 9322000, "max": 18683000, "percentage": 20},
    {"min": 18683000, "percentage": 25}
];

var rates = {};

export const  setRates = (settingRates) => {
    rates = settingRates;
}

export const salariedRentByWage = (data) => {
    var anual = salariedRent(data);
    var total = currentCommons(anual, data);

    return total > 0 ? total : 0;
}

export const salariedAnualRent = (data) => {
    var incomes = parseInt(data.monto_contribuyente) + 
        ( data.ingreso_adicional == 'si' && data.monto_ingreso_adicional ? parseInt(data.monto_ingreso_adicional) : 0 ) -
        ( data.colegio_profesional == 'si' && data.monto_colegio_profesional ? parseInt(data.monto_colegio_profesional) : 0 ) -
        ( data.pension == 'si' && data.monto_pension ? getPercentIncomes(data) : 0 );

    // Ingresos anuales
    incomes = incomes * 12;
    var totalIncomes = commons(incomes, data);

    return totalIncomes > 0 ? getMountByRate(totalIncomes, rates.AnualRates) : 0;
}

export const freelancerMonthlyRate = (data) => {
    var anual = freelancerRent(data);
    var total = currentCommons(anual, data);

    return total > 0 ? total : 0;
}

export const freelancerAnualRent = (data) => {
    var incomes = parseInt(data.monto_contribuyente) +
        ( data.ingreso_extra == 'si' && data.monto_ingreso_extra ? parseInt(data.monto_ingreso_extra) : 0 ) - 
        ( data.pension == 'si' && data.monto_pension ? getPercentIncomes(data) : 0 ) -
        data.gastos_mesuales;
    
    incomes = incomes * 12;
    var totalIncomes = commons(incomes, data);

    return totalIncomes > 0 ? getMountByRate(totalIncomes, rates.AnualRates) : 0;
}

export const currentSalariedAndFreelances = (data) => {
    var salariedIncome = parseInt(data.monto_contribuyente); 
    var freelancerIncome = parseInt(data.monto_contribuyente2) + ( data.ingreso_extra == 'si' && data.monto_ingreso_extra ? parseInt(data.monto_ingreso_extra) : 0 );
    // var freelancerIncome = parseInt(data.monto_contribuyente2) + ( data.ingreso_extra == 'si' && data.monto_ingreso_extra ? parseInt(data.monto_ingreso_extra) : 0 ) - data.gastos_mesuales;

    var salaried = salariedIncome;
    var freelance = freelancerIncome;

    if( salariedIncome >= freelancerIncome ) {
        salaried = salaried - ( data.pension == 'si' && data.monto_pension ? getPercentIncomes(data) : 0 );
        freelance = freelance - data.gastos_mesuales;
    } else {
        freelance = freelance - ( data.pension == 'si' && data.monto_pension ? getPercentIncomes(data) : 0 ) - data.gastos_mesuales;
    }

    salaried = getMountByRate(salaried, rates.wageMonthlyRates) * 12;
    
    var newRates = rates.freelancerRates.map( rate => { return {...rate} } );

    // Restamos lo exonerado ya que no se puede exonerar doble
    if(salaried <= 0) {
        var anualWage = salariedIncome * 12;
        var diff = newRates[0].max - anualWage;

        if( diff <= 0 ) {
            //corre impuesto a partir del primer ingreso
            newRates.shift();
            newRates[0].min = 0;
        } else {
            newRates[0].max = diff;
            newRates[1].min = diff;
        }
    } else {
        //corre impuesto a partir del primer ingreso
        newRates.shift();
        newRates[0].min = 0;
    }

    freelance = getMountByRate(freelance * 12, newRates);
    var total = currentCommons(salaried + freelance, data);

    return total > 0 ? total : 0;
}

export const currentSalariedAndSalaried = (data) => {
    var wage1 = data.monto_contribuyente;
    var wage2 = data.monto_contribuyente2;
    
    if( wage1 >= wage2 && data.pension == 'si' && data.monto_pension ) {
        let incomesPercent = (wage1 * 10) / 100;
        let percentMount = data.monto_pension <= incomesPercent ? data.monto_pension : incomesPercent;
        wage1 = wage1 - percentMount;
    } else if( wage2 > wage1 && data.pension == 'si' && data.monto_pension ) {
        let incomesPercent = (wage2 * 10) / 100;
        let percentMount = data.monto_pension <= incomesPercent ? data.monto_pension : incomesPercent;
        wage2 = wage2 - percentMount;
    }

    wage1 = getMountByRate(wage1, rates.wageMonthlyRates) * 12;
    wage2 = getMountByRate(wage2, rates.wageMonthlyRates) * 12;

    var total = currentCommons(wage1 + wage2, data);
    return total > 0 ? total : 0;

}

export const salariedAndFreelances = (data) => {
    var incomes = parseInt(data.monto_contribuyente) + parseInt(data.monto_contribuyente2) +
    ( data.ingreso_adicional == 'si' && data.monto_ingreso_adicional ? parseInt(data.monto_ingreso_adicional) : 0 ) +
    ( data.ingreso_extra == 'si' && data.monto_ingreso_extra ? parseInt(data.monto_ingreso_extra) : 0 );
    
    if( data.pension == 'si' && data.monto_pension ) {
        var incomesPercent = (incomes * 10) / 100;
        var percentMount = data.monto_pension <= incomesPercent ? data.monto_pension : incomesPercent;

        incomes = incomes - percentMount;
    }
    
    incomes = incomes - parseInt(data.gastos_mesuales) -
    ( data.colegio_profesional == 'si' && data.monto_colegio_profesional ? parseInt(data.monto_colegio_profesional) : 0 );

    incomes = incomes * 12;
    var totalIncomes = commons(incomes, data);
    return totalIncomes > 0 ? getMountByRate(totalIncomes, rates.AnualRates) : 0;
}

export const salariedAndSalaried = (data) => {
    var incomes = parseInt(data.monto_contribuyente) + parseInt(data.monto_contribuyente2) +
    ( data.ingreso_adicional == 'si' && data.monto_ingreso_adicional ? parseInt(data.monto_ingreso_adicional) : 0 ) -
    ( data.pension == 'si' && data.monto_pension ? getPercentIncomes(data) : 0 ) -
    ( data.colegio_profesional == 'si' && data.monto_colegio_profesional ? parseInt(data.monto_colegio_profesional) : 0 );

    incomes = incomes * 12;
    var totalIncomes = commons(incomes, data);
    return totalIncomes > 0 ? getMountByRate(totalIncomes, rates.AnualRates) : 0;
}

export const formatNumber = (number) => {
    return `₡ ${number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}`;
}

const salariedRent = (data) => {
    var mount = data.monto_contribuyente - ( data.pension == 'si' && data.monto_pension ? getPercentIncomes(data) : 0 );
    
    return getMountByRate(mount, rates.wageMonthlyRates) * 12;
}

const freelancerRent = (data) => {
    var incomes = parseInt(data.monto_contribuyente) +
        ( data.ingreso_extra == 'si' && data.monto_ingreso_extra ? parseInt(data.monto_ingreso_extra) : 0 ) - 
        ( data.pension == 'si' && data.monto_pension ? getPercentIncomes(data) : 0 ) -
        data.gastos_mesuales;

    return getMountByRate(incomes * 12, rates.freelancerRates);
}

const getMountByRate = (mount, ratesTable) => {
    return Math.round(ratesTable.reduce((totalTax, rate) => {
        // Ultimo escalón de la tabla
        if(rate.max === undefined && mount >= rate.min) {
            totalTax = totalTax + (( mount - rate.min ) * rate.percentage) / 100;
        } else if( rate.min < mount && rate.max >= mount && rate.percentage > 0 ) {
            totalTax = totalTax + (( mount - rate.min ) * rate.percentage) / 100;
        } else if(mount > rate.max && rate.percentage > 0) {
            totalTax = totalTax + ( rate.max - rate.min ) * (rate.percentage / 100);
        }
        
        return totalTax;
    }, 0));
}

const commons = (anualMount, data) => {
    if ( data.tiene_discapacidad === "si" ) {
        anualMount = anualMount - rates.common_rates.disability;
    } if ( data.hijos === "si" && parseInt(data.monto_hijos, 10) > 0 ) {
        anualMount = anualMount - ( parseInt(data.monto_hijos, 10) * rates.common_rates.child );
    } if ( data.hijos_menores === "si" && parseInt(data.monto_hijos_menores, 10) > 0 ) {
        anualMount = anualMount - ( parseInt(data.monto_hijos_menores, 10) * rates.common_rates.school_child );
    } if ( data.hijos_discapacidad === "si" && parseInt(data.monto_hijos_discapacidad, 10) > 0 ) {
        anualMount = anualMount - ( parseInt(data.monto_hijos_discapacidad, 10) * rates.common_rates.disability_child );
    } if ( data.conyuge === "si" ) {
        anualMount = anualMount - rates.common_rates.partner;
    }

    return anualMount - rates.common_rates.freeMount;
}

const currentCommons = (anualMount, data) => {
    if ( data.hijos === "si" && parseInt(data.monto_hijos, 10) > 0 ) {
        anualMount = anualMount - ( parseInt(data.monto_hijos, 10) * rates.current_commons.child );
    } if ( data.conyuge === "si" ) {
        anualMount = anualMount - rates.current_commons.partner;
    }

    return anualMount;
}

const getPercentIncomes = (data, percent = 10) => {
    var mount = 0;
    switch(data.contribuyente) {
        case 'asalariado': mount = parseInt(data.monto_contribuyente); break;
        case 'independiente': 
            mount = parseInt(data.monto_contribuyente) + ( data.ingreso_extra == 'si' && data.monto_ingreso_extra ? parseInt(data.monto_ingreso_extra) : 0 );
            break;
        case 'ambas':
            var salaried = parseInt(data.monto_contribuyente);
            var freelance = parseInt(data.monto_contribuyente2) + ( data.ingreso_extra == 'si' && data.monto_ingreso_extra ? parseInt(data.monto_ingreso_extra) : 0 );
            mount = salaried >= freelance ? salaried : freelance;
            break;
        case 'ambasymas': mount = parseInt(data.monto_contribuyente) + parseInt(data.monto_contribuyente2) + ( data.ingreso_adicional == 'si' && data.monto_ingreso_adicional ? parseInt(data.monto_ingreso_adicional) : 0 ); break;
    }

    var incomesPercent = (mount * percent) / 100;
    var percentMount = data.monto_pension <= incomesPercent ? data.monto_pension : incomesPercent;

    return percentMount;
}